const SOCKIT = {
  HOME: "sockit",
  RESULTS: "sockit/results"
}

export { SOCKIT };